import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=b607d3da&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=b607d3da&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607d3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b607d3da')) {
      api.createRecord('b607d3da', component.options)
    } else {
      api.reload('b607d3da', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=b607d3da&scoped=true", function () {
      api.rerender('b607d3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-research/components/Function.vue"
export default component.exports